import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPdfOcr = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect width={32} height={32} fill="#F43F3F" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.75 7.243v3.717c0 .504 0 .756.095.949.084.169.218.307.383.393.187.098.432.098.922.098h3.614M23 14.19v6.49c0 1.512 0 2.268-.286 2.846a2.66 2.66 0 0 1-1.147 1.18C21.005 25 20.27 25 18.8 25h-5.6c-1.47 0-2.205 0-2.767-.294a2.66 2.66 0 0 1-1.147-1.18C9 22.948 9 22.192 9 20.68v-9.36c0-1.512 0-2.268.286-2.846a2.66 2.66 0 0 1 1.147-1.18C10.995 7 11.73 7 13.2 7h2.81c.642 0 .963 0 1.265.075q.404.1.76.323c.264.167.491.4.945.867l2.79 2.87c.454.467.68.7.843.973.144.241.25.505.314.78.073.31.073.641.073 1.301"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M6 17.25h20"
    />
  </svg>
);
export default SvgPdfOcr;
